import { useEffect, useState } from 'react';
import type { IPatient } from '../../../../common/interfaces/patient';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { RequestStatus } from '../../../../common/enums/requestStatus';
import { getDisplayName } from '../../../../common/utils/getDisplayName';
import { translateKey } from '../../../translate';
import { useAbortableFetch } from '../../../utils/hooks/useAbortableFetch';
import { PrintButton } from '../common';

interface IPrintCarePathButtonProps {
    hidePrintButton?: boolean;
    isLastItem: boolean;
    isPreviousRequest?: boolean;
    request: IRequestGetOne;
}

export function PrintCarePathButton(props: IPrintCarePathButtonProps) {
    const { request, isLastItem, isPreviousRequest, hidePrintButton } = props;
    const [patient, setPatient] = useState<IPatient>();
    const abortableFetch = useAbortableFetch();

    useEffect(() => {
        loadPatient(request.patientId);
    }, []);

    async function loadPatient(patientId: string) {
        const result = await abortableFetch.fetchJson(`/api/patients/${patientId}`, 'GET');
        setPatient(result.json);
    }

    if (request.status === RequestStatus.draft || !isLastItem || isPreviousRequest || hidePrintButton) {
        return null;
    }

    return <PrintButton onClick={async () => await openPdfOnNewPage(patient!, request)} />;

    async function openPdfOnNewPage(patientToPrint: IPatient, requestToPrint: IRequestGetOne) {
        const downloadUrl = getDownloadUrl(patientToPrint, requestToPrint);
        window.open(downloadUrl, '_blank');
    }

    function getDownloadUrl(patientToPrint: IPatient, requestToPrint: IRequestGetOne) {
        const fileName = encodeURIComponent(
            `${getDisplayName(patientToPrint)} - ${translateKey(
                `episodeCategoryEnum.${requestToPrint.episodeCategory}`
            )}.pdf`
        );

        return `/api/makePdf/${requestToPrint.patientId}/${requestToPrint.episodeCategory}/${fileName}?requestId=${requestToPrint.id}`;
    }
}
